import { inject, PLATFORM} from 'aurelia-framework';
import {EventAggregator} from 'aurelia-event-aggregator';
// Calendar info
var calendar = {
	years:[],
	months:["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	days:[],
}
	

@inject(EventAggregator)
export class DatePicker {

	constructor(ea){
		this.calendar = calendar;
		this.generateYears();
		this.model = { year:0, month:"", day:1 };
		this.ea = ea;

		// test block
		//this.setDefaultDate();
		// end test block
	}

	generateYears(){
		for(var i = 2016; i > 1955; i--){
			this.calendar.years.push(i);
		}

	}
	
	getDaysByMonth(){
		this.calendar.days = [];
		//var month = this.calendar.months.indexOf(this.model.month) + 1;
		var month = this.calendar.months.indexOf(this.model.month);

		let daysInMonth = new Date(this.model.year, month, 0).getDate();
		
		for(var i = 1; i < (daysInMonth + 1); i++){
			this.calendar.days.push(i);
		}
	}

	generateDate(){
		try{
			//let month = this.calendar.months.indexOf(this.model.month) + 1;
			let month = this.calendar.months.indexOf(this.model.month);
			let day = this.model.day
			let year = this.model.year;
			let date = new Date(year, month, day).toISOString();
			return date;
		}catch(err){ console.log(err);}
	}

	onChange(){
		this.getDaysByMonth();
		let mydate = this.generateDate();
		let message = { body:mydate };
		this.ea.publish('date-picker:change', message)
	}

	// Test block
	setDefaultDate(){
		// test date
		let testDate = "2007-09-08T05:00:00.000Z";
		let myDate = new Date(testDate);
		
		const myMonth = myDate.getMonth();
		const myDay = myDate.getDate();
		const myYear = myDate.getFullYear();

		let myStringDate = myMonth + " " + myDay + ", " + myYear;
		console.log(myStringDate);

		this.picker = { "year":2007 }
		this.onChange();

	}
	// end test 

	
}
